import { AccompanimentType, FileType } from "shared/types/types";
import React, { useContext, useEffect, useState } from "react";

import { AccompaniementsContext } from "features/accompaniment";
import DocsPerOrganisms from "features/accompaniment/components/DocsPerOrganisms";
import { DocumentUnion } from "shared/types/types";
import File from "components/File";
import FileUploader from "components/FileUploader";
import HeaderSection from "components/HeaderSection";
import PageHeader from "components/PageHeader";
import StatusAccompagnement from "features/accompaniment/components/StatusAccompagnement";
import Table from "components/Table";
import { UserContext } from "features/account";
import { addDocumentToAccompaniment } from "features/accompaniment";
import { useLostDocumentsByAccompanimentId} from "features/lost";
import { useParams } from "react-router-dom";
import { formattedStringToDate } from "utils/utils";
import { ASSISTANCE_PRICING } from "shared/config/pricings";
import { getSubscription } from "features/account";

const columns = [
    { key: "nationality", label: "" },
    { key: "type", label: "Type de document" },
    { key: "number", label: "Numéro" },
    { key: "createdAt", label: "Date de l'ajout" },
    { key: "dateExpiration", label: "Exp" },
    { key: "status", label: "Statut" },
    { key: "isBlocked", label: "" },
];

const IDAssistantDetail = () => {
    let { id } = useParams();

    const [selectedRows, setSelectedRows] = useState<DocumentUnion[]>([]);
    const { accompaniments, refreshAccompaniments } = useContext(AccompaniementsContext);
    const { userType } = useContext(UserContext);
    const [currentAccompaniment, setCurrentAccompaniment] = useState<AccompanimentType>();
    const { data: documentsLost, error: errorLostDocuments } = useLostDocumentsByAccompanimentId(userType, id);
    const [accompanimentDocuments, setAccompanimentDocuments] = useState<DocumentUnion[]>([]);
    const [userLastAccompanimentPaid, setUserLastAccompanimentPaid] = useState<any>(ASSISTANCE_PRICING[1]);


    const fileUploaderProps = {
        className: "mb-0",
        title: "Ajouter un procès verbal de perte ou de vol",
        allowedFormats: "application/pdf, image/jpeg, image/png",
        onDelete: () => console.log("delete"),
        onChange: (files: any) => handleAddDocument(files),
        isList: false,
    };

    useEffect(() => {
        if (!id || !accompaniments) return;
        // console.log(id);
        setCurrentAccompaniment(accompaniments.find((item) => item?.id?.toString() === id));
    }, [id, accompaniments]);

    useEffect(() => {
        if (!documentsLost) return;
        setAccompanimentDocuments(documentsLost);
        // console.log(documentsLost);
    }, [documentsLost, documentsLost?.documents_ids]);

    const handleSelectionChange = (rows: DocumentUnion[]) => {
        setSelectedRows(rows);
    };

    const handleAddDocument = async (files: any) => {
        try {
            const response = await addDocumentToAccompaniment(userType, files[0], currentAccompaniment?.id);
            if (response) {
                await refreshAccompaniments(); // ← recharge uniquement les données
            }
        } catch (error) {
            console.log(error);

        }
    };

    useEffect(() => {
        const getOffer = async () => {
            try {
                ASSISTANCE_PRICING.map((offer) => {
                    if (currentAccompaniment?.offreId === offer.offreId) {
                        setUserLastAccompanimentPaid(offer);
                    }
                })
            } catch (error) {
                console.log(error);
            }
        };

        getOffer();
    }, [currentAccompaniment?.id]);

    const handleFilePath = (file: FileType) => {
        const { path } = file;
        const splitPath = path.split("/");
        const clientNumber = splitPath[0];
        const accompanimentId = splitPath[splitPath.length - 2];
        const fileName = splitPath[splitPath.length - 1];
        ///client/getAcconpagnementFile/:clientNumber/:accompanimentId/:fileName
        return `client/getAcconpagnementFile/${clientNumber}/${accompanimentId}/${fileName}`;
    };

    return (
        <>
            <PageHeader
              showBackBtn={true}
              title={`ID Assistant - ${formattedStringToDate(currentAccompaniment?.createdAt ?? "")}`}
              description={`${userLastAccompanimentPaid?.title}`}
              notification={true}
            >
            </PageHeader>
            <div className="content__body">
                <div className="row">
                    <div className="col-lg-12">
                        {currentAccompaniment?.status && <StatusAccompagnement status={currentAccompaniment?.status} offreId={currentAccompaniment?.offreId} />}
                        <HeaderSection
                            title="Documents perdus/volés dans cet accompagnement"
                            // number=""
                        />
                        <Table
                            isClickable={false}
                            selectable={false}
                            columns={columns}
                            rows={accompanimentDocuments}
                            onSelectionChange={handleSelectionChange}
                            selectedRows={selectedRows}
                            editable={false}
                            fixStatusToPerte={true}
                        />

                        <DocsPerOrganisms organisms={currentAccompaniment?.accompaniementContacts}
                                          offreId={currentAccompaniment?.offreId}
                                          status={currentAccompaniment?.status}
                        />
                        <HeaderSection
                            title="Ma déclaration de perte ou de vol"
                            // number="1"
                        />

                        <div className={"d-flex gap-2"}>
                            {currentAccompaniment?.accompanimentClientDocuments.map((clientDoc) => {
                                return (
                                  <File file={clientDoc} />
                                );
                            })}
                            {currentAccompaniment?.status === 'Traitement du dossier' && (
                              <FileUploader {...fileUploaderProps} />
                            )}
                        </div>

                    </div>
                </div>
            </div>
        </>
    );
};

export default IDAssistantDetail;
